<template>
  <div id="app" class="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      isAuthPage: false,
      isVideoPage: false,
    };
  },
};
</script>

<style lang="scss">
@import '@assets/styles/common';
@import '@assets/styles/bootstrap';

.app {
  width: 100%;
  height: 100%;

  main {
    position: relative;
    height: 100%;
    background-color: $gray-f1;
  }
}
</style>
